import { useEffect } from "react";
import { applyScreenScale } from "../helpers/screenScale";

/**
 * Keeps the document zoom in sync with the window width.
 * `resize` also fires when the window moves to a monitor with a different
 * Windows display scaling, so that case is covered too.
 */
export default function ScreenScaleInitializer() {
  useEffect(() => {
    let frame = 0;
    const onResize = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => applyScreenScale());
    };

    applyScreenScale();
    window.addEventListener("resize", onResize);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return null;
}
